import { render, staticRenderFns } from "./ListProfile.vue?vue&type=template&id=44e12d8a&scoped=true"
import script from "./ListProfile.vue?vue&type=script&lang=js"
export * from "./ListProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e12d8a",
  null
  
)

export default component.exports